import Header from "@components/navigation/Header";
import Sidebar from "@components/navigation/Sidebar";
import { useUIStore } from "@store/uiStore";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

export default function MainLayout() {
  const sidebarOpen = useUIStore((state) => state.sidebarOpen);
  const setSidebarOpen = useUIStore((state) => state.setSidebarOpen);

  // Keep the drawer state in sync with the viewport: collapse to off-canvas on
  // mobile, restore expanded on desktop when crossing the lg breakpoint.
  useEffect(() => {
    const mq = window.matchMedia("(min-width: 1024px)");
    const handler = (e: MediaQueryListEvent) => setSidebarOpen(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [setSidebarOpen]);

  return (
    <div className="flex h-screen bg-sand-50">
      {/* Sidebar */}
      <Sidebar />

      {/* Main content */}
      <div
        className={`flex min-w-0 flex-1 flex-col transition-all duration-300 ${
          sidebarOpen ? "lg:ml-64" : "lg:ml-20"
        }`}
      >
        {/* Header */}
        <Header />

        {/* Page content */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden p-4 sm:p-6 lg:p-8">
          <div className="mx-auto max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
